 <template>
  <div>
    <div class="extra input-group">
      <InputField
        target="START_DATE"
        label="Mortgage start date"
        class="start-date input"
        :value="FORMATED_START_DATE"
        :update="update"
        type="date"
      />
      <InputField
        target="EXTRA_MONTHLY_PAYMENT_AMOUNT"
        label="Add extra payment:"
        class="extra-payment input"
        :value="showValue(FORMATED_EXTRA_PAYMENT,'EXTRA_MONTHLY_PAYMENT_AMOUNT', '')"
        :prefix="dollar"
        :update="update"
      />
    </div>
    <div class="annual input-group">
      <InputField
        target="ANNUAL_PAYMENT_AMOUNT"
        label="Annual Payment:"
        class="annual-payment-amount input"
        :value="showValue(FORMATED_ANNUAL_PAYMENT_AMOUNT,'ANNUAL_PAYMENT_AMOUNT', '')"
        :update="update"
        :prefix="dollar"
      />
      <InputField
        target="ANNUAL_PAYMENT_DATE"
        label="Every"
        class="extra-payment-date input"
        :value="FORMATED_ANNUAL_PAYMENT_DATE"
        :update="update"
        type="select"
        :months="months"
        :suffix="selectArrow"
      />
    </div>
    <div class="one-time input-group">
      <InputField
        target="ONE_TIME_PAYMENT_AMOUNT"
        label="One time payment:"
        class="one-time-payment-amount input"
        :value="showValue(FORMATED_ONE_TIME_PAYMENT_AMOUNT,'ONE_TIME_PAYMENT_AMOUNT', '')"
        :update="update"
        :prefix="dollar"
      />
      <InputField
        target="ONE_TIME_PAYMENT_DATE"
        label="On:"
        class="one-time-payment-date input"
        :value="FORMATED_ONE_TIME_PAYMENT_DATE"
        :update="update"
        type="date"
        format="MMMM, YYYY"
      />
    </div>

    <div
      v-if="extrasGreaterThanPrinciple"
      class="errors"
    >{{state.ERRORS.PAYOFF_ADJUSTMENTS_FORM[0]}}</div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import moment from "moment";
import { STATE, MUTATIONS, GETTERS, ACTIONS } from "../storeConstants";
import InputField from "./util/InputField";
import dollar from "../../public/dollar-sign.svg";
import selectArrow from "../../public/keyboard_arrow_down-24px.svg";
import formatDate from "../util/format";
import { checkValidation } from "../util/validate";
import { roundCurrency, roundDollarsToCents } from "../util/bankersRound";

const {
  UPDATE_ANNUAL_PAYMENT_AMOUNT,
  UPDATE_ONE_TIME_PAYMENT_DATE,
  UPDATE_ANNUAL_PAYMENT_DATE,
  UPDATE_ONE_TIME_PAYMENT_AMOUNT,
  UPDATE_EXTRA_MONTHLY_PAYMENT_AMOUNT,
  UPDATE_MORTGAGE_START_DATE
} = ACTIONS;
const {
  FORMATED_START_DATE,
  FORMATED_EXTRA_PAYMENT,
  FORMATED_ANNUAL_PAYMENT_AMOUNT,
  FORMATED_ANNUAL_PAYMENT_DATE,
  FORMATED_ONE_TIME_PAYMENT_AMOUNT,
  FORMATED_ONE_TIME_PAYMENT_DATE,
  MODIFIED_TERM,
  PAYMENT
} = GETTERS;
const { CHANGE } = MUTATIONS;

export default {
  data: () => {
    return {
      dollar: dollar,
      selectArrow: selectArrow,
      months: [
        "January",
        "Feburay",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ]
    };
  },
  computed: {
    ...mapState({
      state: state => state.base
    }),
    ...mapGetters([
      MODIFIED_TERM,
      PAYMENT,
      FORMATED_START_DATE,
      FORMATED_EXTRA_PAYMENT,
      FORMATED_ANNUAL_PAYMENT_AMOUNT,
      FORMATED_ANNUAL_PAYMENT_DATE,
      FORMATED_ONE_TIME_PAYMENT_AMOUNT,
      FORMATED_ONE_TIME_PAYMENT_DATE
    ]),
    extrasGreaterThanPrinciple() {
      //if there are other errors clear them first
      if (typeof this.state.ERRORS["PAYOFF_ADJUSTMENTS_FORM"] !== "undefined") {
        let clearErrors = { ...this.state.ERRORS };
        delete clearErrors.PAYOFF_ADJUSTMENTS_FORM;
        if (typeof clearErrors[STATE.ONE_TIME_PAYMENT_AMOUNT] !== "undefined") {
          clearErrors[STATE.ONE_TIME_PAYMENT_AMOUNT] = clearErrors[
            STATE.ONE_TIME_PAYMENT_AMOUNT
          ].filter(item => item !== "");
        }
        if (typeof clearErrors[STATE.ANNUAL_PAYMENT_AMOUNT] !== "undefined") {
          clearErrors[STATE.ANNUAL_PAYMENT_AMOUNT] = clearErrors[
            STATE.ANNUAL_PAYMENT_AMOUNT
          ].filter(item => item !== "");
        }
        if (
          typeof clearErrors[STATE.EXTRA_MONTHLY_PAYMENT_AMOUNT] !== "undefined"
        ) {
          clearErrors[STATE.EXTRA_MONTHLY_PAYMENT_AMOUNT] = clearErrors[
            STATE.EXTRA_MONTHLY_PAYMENT_AMOUNT
          ].filter(item => item !== "");
        }

        this.CHANGE({ target: STATE.ERRORS, value: clearErrors });
        Object.keys(this.state.ERRORS).forEach(error => {
          if (this.state.ERRORS[error].length === 0)
            delete this.state.ERRORS[error];
        });
      }
      //only set this error if there are no other errors
      if (Object.keys(this.state.ERRORS).length === 0) {
        let totalExtraPayments =
          this.state.EXTRA_MONTHLY_PAYMENT_AMOUNT * this.state.TERM +
          this.state.ONE_TIME_PAYMENT_AMOUNT +
          this.state.ANNUAL_PAYMENT_AMOUNT * (this.state.TERM / 12);
        //if there is no error, exit
        if (
          totalExtraPayments <=
          this.state.PAYMENT_DATA[this.state.PAYMENT_DATA.length - 1].interest +
            this.state.PAYMENT_DATA[this.state.PAYMENT_DATA.length - 1]
              .principle
        )
          return false;
        //if there is an error update the error state
        this.CHANGE({
          target: STATE.ERRORS,
          value: {
            ...this.state.errors,
            PAYOFF_ADJUSTMENTS_FORM: [
              "Payments must be less than overall mortgage price"
            ],
            [STATE.ONE_TIME_PAYMENT_AMOUNT]: [""],
            [STATE.ANNUAL_PAYMENT_AMOUNT]: [""],
            [STATE.EXTRA_MONTHLY_PAYMENT_AMOUNT]: [""]
          }
        });
        return true;
      }
    }
  },

  methods: {
    ...mapMutations([CHANGE]),
    ...mapActions([
      UPDATE_ANNUAL_PAYMENT_AMOUNT,
      UPDATE_ONE_TIME_PAYMENT_DATE,
      UPDATE_ANNUAL_PAYMENT_DATE,
      UPDATE_ONE_TIME_PAYMENT_AMOUNT,
      UPDATE_EXTRA_MONTHLY_PAYMENT_AMOUNT,
      UPDATE_MORTGAGE_START_DATE
    ]),
    showValue(value, target, errorState) {
      if (
        typeof this.state.ERRORS["PAYOFF_ADJUSTMENTS_FORM"] !== "undefined" &&
        typeof this.state.ERRORS[target] !== "undefined"
      )
        return value;
      return typeof this.state.ERRORS[target] === "undefined" ||
        this.state.ERRORS[target].length === 0
        ? value
        : errorState;
    },
    update(e) {
      let target = e.target.parentNode.id;
      let value = e.target.value;
      const valid = checkValidation({
        state: this.state,
        change: this.CHANGE,
        target,
        value
      });
      const dineroTargets = [
        "EXTRA_PAYMENT",
        "ANNUAL_PAYMENT_AMOUNT",
        "ONE_TIME_PAYMENT_AMOUNT",
        "EXTRA_MONTHLY_PAYMENT_AMOUNT"
      ];
      if (dineroTargets.includes(target))
        value = roundDollarsToCents(value.replace(/[^0-9.-]/g, ""), 10);
      switch (target) {
        case "ONE_TIME_PAYMENT_AMOUNT":
          this.UPDATE_ONE_TIME_PAYMENT_AMOUNT({ target, value });
          break;
        case "ONE_TIME_PAYMENT_DATE":
          this.UPDATE_ONE_TIME_PAYMENT_DATE({ target, value });
          break;
        case "EXTRA_MONTHLY_PAYMENT_AMOUNT":
          this.UPDATE_EXTRA_MONTHLY_PAYMENT_AMOUNT({ target, value });
          break;
        case "START_DATE":
          this.UPDATE_MORTGAGE_START_DATE({ target, value });
          break;
        case "ANNUAL_PAYMENT_AMOUNT":
          this.UPDATE_ANNUAL_PAYMENT_AMOUNT({
            target,
            value
          });
          break;
        case "ANNUAL_PAYMENT_DATE":
          this.UPDATE_ANNUAL_PAYMENT_DATE({ target, value });
          break;
        default:
          this.CHANGE({ target, value });
      }
    }
  },
  components: {
    InputField: InputField
  }
};
</script>
<style scoped lang="scss">
.payoff-adjustment {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  @media (min-width: 768px) {
    margin: 0;
  }
  > * {
    width: 45%;

    margin-bottom: 19px;
    left: -2px;
    position: relative;
    @media (min-width: 768px) {
      margin-bottom: 12;
    }
    @media (min-width: 1024px) {
      margin-bottom: 0;
    }
  }
}
.payoff-adjustment {
  display: inline;
}
.input-group {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.input-field {
  width: 48%;
}
.errors {
  margin-bottom: 0;
  top: -15px;
  font-size: 14px;
  color: red;
  width: 100% !important;
}
.description {
  .title {
    margin-bottom: 0px;
    font-size: 14px;
    font-weight: 600;
  }
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: left;
  color: #282828;
  margin-bottom: 32px;
}
</style>
<style lang="scss">
.payoff-adjustments {
  .one-time-payment-date {
    .vdp-datepicker {
      .vdp-datepicker__calendar {
        right: 0;
      }
    }
  }
}
.one-time-payment-date {
  .vdp-datepicker {
    div {
      input {
        width: 100% !important;
      }
    }

    .vdp-datepicker__calendar {
      right: 0;
    }
  }
}
</style>